import { Injectable } from '@angular/core';
import { AltraParte } from './altraparte';
import { Controparte } from './controparte';
import { DocumentoAllegato } from './documento-allegato';

import { LegaleIncaricato } from './legale-incaricato';
import { Cpa } from './tipologiche/cpa';
import { Iva } from './tipologiche/iva';
import { ModalitaPagamento } from './tipologiche/modalita-pagamento';
import { Motivo } from './tipologiche/motivo';
import { TipoPagamento } from './tipologiche/tipo-pagamento';
import { TipoSommaLiquidata } from './tipologiche/tipo-somma-liquidata';

@Injectable()
export class Pagamento {
  id: string;
  dataPagamento: number;
  tipoPagamento: TipoPagamento;
  modalitaPagamento: ModalitaPagamento;
  motivo: Motivo;
  tipoSommaLiquidata: TipoSommaLiquidata;
  terzoPignorato: AltraParte;
  numeroAutorizzazione: string;
  dataAutorizzazione: number;
  importo: any;
  cpa: Cpa;
  iva: Iva;
  sommaNonSoggettaRitenuta: any;
  flagRitenutaAcconto: boolean;
  legaleIncaricato: LegaleIncaricato;
  controparte: Controparte;
  altraParte: AltraParte;
  note: string;
  documenti: DocumentoAllegato[];
}
